import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from "react";
interface SVGLocationPinProps extends SVGProps<SVGSVGElement> {
  onAnimationIteration?: () => void;
}
export function SVGLocationPin(t0) {
  const $ = _c(7);
  let onAnimationIteration;
  let props;
  if ($[0] !== t0) {
    ({
      onAnimationIteration,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = onAnimationIteration;
    $[2] = props;
  } else {
    onAnimationIteration = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M16 3.45c-4.8 0-8.7 3.9-8.7 8.7 0 4.7 4.2 11.4 8 16 .2.2.4.4.7.4.3 0 .5-.2.7-.4 3.7-4.5 8-11.3 8-16 0-4.713-3.76-8.558-8.44-8.696L16 3.45zm0 13.9c-3 0-5.4-2.4-5.4-5.4 0-3 2.4-5.4 5.4-5.4 3 0 5.4 2.4 5.4 5.4 0 3-2.4 5.4-5.4 5.4z" fill="currentColor" fillRule="evenodd" />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== onAnimationIteration || $[5] !== props) {
    t2 = <svg aria-hidden="true" onAnimationIteration={onAnimationIteration} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>{t1}</svg>;
    $[4] = onAnimationIteration;
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}